import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogType } from '../constants';
import { PosPsychometricEvaluationModalComponent } from 'src/app/shared/pos-psychometric-evaluation-modal/pos-psychometric-evaluation-modal.component';
import { Customer } from 'src/app/models/customer';

@Injectable({
  providedIn: 'root'
})
export class PosPsychometricEvaluationModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) { }
  show(customer: Customer, action: () => any): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      this.modalRef = this.modalService.show(PosPsychometricEvaluationModalComponent,
        {
          ignoreBackdropClick: true
        })
      this.modalRef.content.customer = customer;
      this.modalRef.content.action = action;
      this.modalRef.content.loadQrCode();
      this.modalRef.setClass(`modal-dialog modal-md ${ModalDialogType.PRIMARY}`)
      resolve(true);
    })
  }
}
